package com.anjuros.website.redesign.sections.contactforms

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdLink
import com.anjuros.website.redesign.components.RdTag
import com.anjuros.website.redesign.styles.FormsInboxBarStyle
import com.anjuros.website.redesign.styles.FormsInboxFootStyle
import com.anjuros.website.redesign.styles.FormsInboxStyle
import com.anjuros.website.redesign.styles.FormsMailBodyStyle
import com.anjuros.website.redesign.styles.FormsMailEmptyStyle
import com.anjuros.website.redesign.styles.FormsMailHeadStyle
import com.anjuros.website.redesign.styles.FormsMailStyle
import com.anjuros.website.redesign.util.RdIcons
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText
import com.anjuros.website.redesign.util.rdList
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Aside
import org.jetbrains.compose.web.dom.B
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

/** The enquiry email as it would arrive, built from the form's current answers. */
@Composable
fun InboxPreview(form: DemoForm, values: List<String>) {
    val label = LocalText(RdText.INBOX_LABEL)
    Aside(FormsInboxStyle.toModifier().attrsModifier { attr("aria-label", label); attr("aria-live", "polite") }.toAttrs()) {
        Div(FormsInboxBarStyle.toModifier().toAttrs()) {
            RdIcons.Mail(size = 18)
            Span { Text(LocalText(RdText.INBOX_TITLE)) }
            Span { Text(LocalText(RdText.INBOX_EXAMPLE)) }
        }
        Div(FormsMailStyle.toModifier().toAttrs()) {
            Div(FormsMailHeadStyle.toModifier().toAttrs()) {
                B { Text(LocalText(RdText.INBOX_SUBJECT)) }
                Span { Text(LocalText(RdText.INBOX_TO).replace("%s", LocalText(form.business))) }
            }
            RdTag("dl", FormsMailBodyStyle.toModifier()) {
                form.fields.forEachIndexed { index, field ->
                    val answer = inboxValue(field, values[index])
                    RdTag("dt") { Text(LocalText(field.label)) }
                    RdTag("dd", if (answer.isBlank()) FormsMailEmptyStyle.toModifier() else Modifier) {
                        Text(answer.ifBlank { LocalText(RdText.INBOX_NOT_ANSWERED) })
                    }
                }
            }
        }
        P(FormsInboxFootStyle.toModifier().toAttrs()) {
            Text(LocalText(RdText.INBOX_FOOT_START))
            RdLink(RdRoute.PORTAL) { Text(LocalText(RdText.INBOX_FOOT_LINK)) }
            Text(LocalText(RdText.INBOX_FOOT_END))
        }
    }
}

/** Formats an answer the way it would read in the email. */
private fun inboxValue(field: DemoField, value: String): String = when (field.type) {
    DemoFieldType.CHECKS -> rdList(value).filter { it.isNotBlank() }.joinToString(", ")
    DemoFieldType.DATE -> value.split("-").takeIf { it.size == 3 }?.reversed()?.joinToString("/") ?: value
    else -> value
}